import { colors } from '../stylesheets';

export const getBackgroundColor = (props) => {
  if (props.error) {
    return colors['lightPrimary'];
  }
  if (props.disabled) {
    return colors.lightGray;
  }
  return colors.white;
};

export const getPlaceHolderColor = (props) => {
  if (props.error) {
    return colors['primaryText'];
  }
  if (props.disabled) {
    return colors['grayText'];
  }
  return colors['grayText'];
};
